<template>
    <nav class="nav">
        <div class="nav-logo">
            <nuxt-link :to="navbarHomeLink">
                <img
                    :src="favIcon"
                    alt="favicon"
                />
            </nuxt-link>
        </div>

        <ul class="nav-list">
            <li
                v-for="(item, index) in this.$store.state.navigation.body"
                :key="index"
                :class="[{showLinks: mobile}, {active: index === showDropdown}]"
                class="nav-list-li"
                @mouseenter="onHover(index)"
                @mouseleave="onHover(index)"
                @click="onClick(index)"
            >
                <template v-if="item.slice_type === 'dropdown_menu'">
                    <div class="li-item">
                        <span class="ddm_text">{{item.primary.ddm_text}}</span>
                        <i :class="dropdownMenuIcon" />
                    </div>
                    <div v-if="index === showDropdown" class="li-dropdown">
                        <ul>
                            <li
                                v-for="(link, linkIndex) in item.items"
                                :key="linkIndex"
                                class="li-dropdown-li"
                            >
                                <nuxt-link
                                    class="ddm_link"
                                    :to="$prismic.linkResolver(link.ddm_link)"
                                >
                                    <span class="ddm_link_text">{{link.ddm_link_text}}</span>
                                </nuxt-link>
                            </li>
                        </ul>
                    </div>
                </template>
                <template v-else-if="item.slice_type === 'link'">
                    <nuxt-link
                        :to="$prismic.linkResolver(item.primary.sl_link)"
                        class="sl_link"
                    >
                        <span class="sl_text">{{item.primary.sl_text}}</span>
                    </nuxt-link>
                </template>
            </li>
        </ul>
        <div class="menu-toggle">
            <transition name="menuToggle" mode="out-in">
                <i
                    v-if="!mobile"
                    @click="mobile = true"
                    :class="mobileMenuIconOpen"
                />
                <i
                    v-else
                    @click="mobile = false, showDropdown = undefined"
                    :class="mobileMenuIconClose"
                />
            </transition>
        </div>
        <div
            @click="mobile = false"
            v-if="mobile"
            class="overlay"
        />
    </nav>
</template>

<script>
export default {
    props: {
        favIcon: {
            type: String,
            required: false,
            default: '@/static/favicon.png'
        },
        mobileMenuIconOpen: {
            type: String,
            required: false,
            default: 'fas fa-bars'
        },
        mobileMenuIconClose: {
            type: String,
            required: false,
            default: 'fas fa-times'
        },
        navbarHomeLink: {
            type: String,
            required: false,
            default: '/'
        },
        dropdownMenuIcon: {
            type: String,
            required: false
        },
        navItems: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            mobile: false,
            showDropdown: undefined
        }
    },
    watch: {
        mobile() {
            document.body.style.overflow = this.mobile ? 'hidden' : ''
        },
        '$route'() {
            this.mobile = false;
        }
    },
    methods: {
        onClick(index) {
            if(window.innerWidth < 900) {
                if(this.showDropdown == index) {
                    this.showDropdown = undefined
                } else {
                    this.showDropdown = index;
                }
            }
        },
        onHover(index) {
            if(window.innerWidth > 900) {
                if(this.showDropdown == index) {
                    this.showDropdown = undefined
                } else {
                    this.showDropdown = index;
                }
            }
        }
    },
    beforeMount() {
        document.body.style.overflow = 'visible'
    }
}
</script>
<style lang="scss">
.nav {
    position: absolute;
    width: 100%;
    left: 0; top: 0;
    z-index: 99;

    @media screen and (min-width: 900px) {
        position: fixed;
    }

    .overlay {
        z-index: 2;
    }

    ul, a, .toggle {
        z-index: 3;
    }

    &-logo {
        width: 100%;

        @media screen and (min-width: 900px) {
            width: auto;
        }
    }
    &-list {
        width: 100%;

        @media screen and (min-width: 900px) {
            width: none;
            flex: 1;
        }

        &-li {
            position: relative;

            i {
                animation: spinLeave .15s ease;
                animation-fill-mode: forwards;
            }

            .li-dropdown {
                animation: dropdown .15s ease;
            }
        }
    }
    .showLinks {
        display: block;
    }
    .active {
        i {
            animation: spin .15s ease;
            animation-fill-mode: forwards;
        }
    }
}
</style>
